import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-contact',
  imports: [],
  templateUrl: './contact.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.scss',
})
export class Contact {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Contact Us';
  protected readonly seoDescription =
    'Get in touch with Mari Group for partnerships, media inquiries, or collaborations. Let’s build unforgettable experiences together.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Contact', path: '/contact' },
      ],
    });
  }
}
